export const UNKNOWN_ASSET_GROUP = 'OTHER'

const ASSET_GROUP_LABELS: Record<string, string> = {
  ETH: 'ETH',
  USD: 'USD',
  BTC: 'BTC',
  EURO: 'EUR',
  OTHER: 'Other',
}

const ASSET_GROUP_TOKENS: Record<string, string> = {
  ETH: 'ETH',
  USD: 'USDC',
  BTC: 'BTC',
  EURO: 'EURC',
  OTHER: 'fallback',
}

export function getAssetGroupLabel(assetGroup: string) {
  return ASSET_GROUP_LABELS[assetGroup] ?? assetGroup
}

export function getAssetGroupToken(assetGroup: string) {
  return ASSET_GROUP_TOKENS[assetGroup] ?? 'fallback'
}
